import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/internal-actions';
import { InternalActions } from '../constants';
import { IInternal } from 'src/types/internal';

export interface InternalState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<IInternal>;
    current: IInternal | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    data: {
        list: [],
        page: 1,
        inProgress: false,
        meta: {
            updatedAt: null,
        },
    },
    current: null,
    currentFiles: null,
};

export function internals(state: InternalState = initialState, action: Actions | any): InternalState {
    switch (action.type) {
        case requestType(InternalActions.PERSIST_INTERNAL):
            return { ...state, error: '', inProgress: true };
        case successType(InternalActions.PERSIST_INTERNAL):
            return { ...state, inProgress: false };
        case failureType(InternalActions.PERSIST_INTERNAL):
            return { ...state, error: action.error, inProgress: false };
        case requestType(InternalActions.FETCH_INTERNALS):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    page: 1,
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(InternalActions.FETCH_INTERNALS):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(InternalActions.FETCH_INTERNALS):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(InternalActions.FETCH_INTERNAL):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(InternalActions.FETCH_INTERNAL):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(InternalActions.FETCH_INTERNAL):
            return { ...state, inProgress: false, error: action.error };
        case requestType(InternalActions.DELETE_INTERNAL):
            return { ...state, error: '', inProgress: true };
        case successType(InternalActions.DELETE_INTERNAL):
            let idDel = action.payload.id;
            if (!idDel) {
                idDel = action.sagaPayload.id;
            }
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: IInternal) => {
                        return user.id !== idDel;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(InternalActions.DELETE_INTERNAL):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };
        default:
            return state;
    }
}
